<template>
    <layout-sidebar>
        <div id="pdd-tools">
            <router-view></router-view>
        </div>
    </layout-sidebar>
</template>

<script>
    export default {
        name: "pdd-tools"
    }
</script>

<style lang="scss">


</style>